import flatten from 'flat'
import consola from 'consola'

const logger = consola.withTag('Message')

export default {
  methods: {
    listen () {
      if (this.$cms) {
        logger.trace('Subscribing to CMS messages')
        window.addEventListener(
          'message',
          this.handleMessages,
          false
        )
      }
    },
    unlisten () {
      logger.trace('Unsubscribing from CMS messages')
      window.removeEventListener(
        'message',
        this.handleMessages,
        false
      )
    },
    sendMessage (message) {
      if (this.$cms) {
        logger.info('Sending message to CMS with', message)
        window.parent.postMessage(message, '*')
      }
    },
    sendResourceSelectedMessage (payload) {
      this.sendMessage({
        event: 'cms:resourceSelected',
        payload: payload.id
      })
    },
    frontendInitializedMessage () {
      this.sendMessage({
        event: 'cms:frontendInitialized'
      })
    },
    resourceEditedMessage ({ resource }) {
      this.sendMessage({
        event: 'cms:resourceEdited',
        payload: { resource: {
          ...resource,
          columns: flatten(resource.columns)
        } }
      })
    },
    editResourceMessage ({resource}) {
      this.sendMessage({
        event: 'cms:editResource',
        payload: { resource: {
          ...resource,
          columns: flatten(resource.columns)
        } }
      })
    },
    routeChangedMessage (payload) {
      this.sendMessage({
        event: 'cms:routeChanged',
        payload
      })
    }
  }
}
